const resultsBlockCards = () => document.querySelectorAll('[data-results-card]');

const updateResultsBlockToggles = () => {
  resultsBlockCards().forEach((card) => {
    const preview = card.querySelector('[data-results-preview]');
    const full = card.querySelector('[data-results-full]');
    const toggle = card.querySelector('[data-results-toggle]');

    if (!preview || !toggle) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    const isOverflowing = preview.scrollHeight > preview.clientHeight + 1;

    if (isExpanded) {
      toggle.hidden = false;
      toggle.classList.remove('hidden');
      if (full) {
        full.hidden = false;
      }
      return;
    }

    toggle.hidden = !isOverflowing;
    toggle.classList.toggle('hidden', !isOverflowing);

    if (full) {
      full.hidden = true;
      full.classList.add('hidden');
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  updateResultsBlockToggles();
});

window.addEventListener('resize', () => {
  window.requestAnimationFrame(updateResultsBlockToggles);
});

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-results-toggle]');

  if (!toggle) return;

  const card = toggle.closest('[data-results-card]');

  if (!card) return;

  const preview = card.querySelector('[data-results-preview]');
  const full = card.querySelector('[data-results-full]');
  const expanded = toggle.getAttribute('aria-expanded') === 'true';
  const nextExpanded = !expanded;
  const moreLabel = toggle.dataset.moreLabel || 'Show more';
  const lessLabel = toggle.dataset.lessLabel || 'Show less';

  toggle.setAttribute('aria-expanded', String(nextExpanded));
  toggle.textContent = nextExpanded ? lessLabel : moreLabel;

  if (preview) {
    preview.classList.toggle('hidden', nextExpanded);
  }

  if (full) {
    full.hidden = !nextExpanded;
    full.classList.toggle('hidden', !nextExpanded);
  }
});
